import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { ActivitiesComponent } from './activities/activities.component';
import { ExploreComponent } from './explore/explore.component';

import {
    NgbDropdownModule,
    NgbCollapseModule,
    NgbAccordionModule,
    NgbDatepickerModule,
    NgbButtonsModule,
    NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap';
import { FundComponent } from './fund/fund.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WithdrawComponent } from './withdraw/withdraw.component';
import { Angular4PaystackModule } from 'angular4-paystack';
import { NgxCurrencyModule } from 'ngx-currency';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SearchPipe } from '../../../core/pipes/search.pipe';
import { CoreModule } from '../../../core/core.module';

const routes: Routes = [
    {
        path: '',
        component: DashboardComponent,
        children: [
            {
                path: '',
                redirectTo: 'portfolio',
                pathMatch: 'full',
            },
            {
                path: 'portfolio',
                component: PortfolioComponent,
            },
            {
                path: 'activities',
                component: ActivitiesComponent,
            },
            {
                path: 'explore',
                component: ExploreComponent,
            },
            {
                path: 'fund',
                component: FundComponent,
            },
            {
                path: 'withdraw',
                component: WithdrawComponent,
            },
            // Account Subsection
            {
                path: 'account',
                loadChildren: () =>
                    import('./account/account.module').then(
                        (m) => m.AccountModule
                    ),
            },
        ],
    },
];
@NgModule({
    declarations: [
        DashboardComponent,
        PortfolioComponent,
        ActivitiesComponent,
        ExploreComponent,
        FundComponent,
        SearchPipe,
        WithdrawComponent,
    ],
    imports: [
        CommonModule,
        CoreModule,
        RouterModule.forChild(routes),
        NgbDropdownModule,
        NgbCollapseModule,
        NgbAccordionModule,
        NgbButtonsModule,
        NgbDatepickerModule,
        NgbPaginationModule,
        FormsModule,
        ReactiveFormsModule,
        NgxSpinnerModule,
        NgxCurrencyModule,
        Angular4PaystackModule.forRoot(
            'pk_test_e5bb55d844be42b8e2d3aad9304af2e2bc8eae0d'
        ),
    ],
})
export class DashboardModule {}
